<template>
  <fragment>
    <AppBody :subtitle="pageSubtitle">
      <v-row>
        <v-col
          cols="12"
          md="6"
          xl="4"
          v-for="(integration, index) in integrations"
          :key="index"
        >
          <IntegrationCard
            :integration="integration"
            @open-dialog="openDialog($event)"
          />
        </v-col>
      </v-row>
      <IntegrationDialog
        :show="dialog"
        :integration="integration"
        :connectLoading="connectLoading"
        @connect="connectIntegration($event)"
        @close="dialog = false"
      />
    </AppBody>
  </fragment>
</template>

<script>
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import AppBody from "@/layouts/components/AppBody.vue";
import IntegrationCard from "@/components/lojas/Integrations/IntegrationCard.vue";
import IntegrationDialog from "@/components/lojas/Integrations/IntegrationDialog.vue";
import { displayHelpers } from "@/mixins/breakpoints.mixins";
import { mapGetters } from "vuex";
export default {
  name: "Integrations",
  metaInfo() {
    const title = this.$t("registrations.integrations.title");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  mixins: [displayHelpers],
  components: {
    AppBody,
    IntegrationCard,
    IntegrationDialog,
  },
  data() {
    return {
      ENDPOINTS,
      dialog: false,
      connectLoading: false,
      integration: {},
    };
  },
  watch: {
    "$store.getters.storeSequencial": function () {
      this.integrationsList(this.storeSequenciador);
    },
  },
  computed: {
    ...mapGetters(["storeSequencial", "storeInfo", "isAdmin"]),
    pageSubtitle() {
      if (this.isAdmin) {
        if (this.storeInfo.nome_loja === undefined) return "Integrações";
        return `${this.$t("registrations.integrations.title")} - ${
          this.storeInfo.nome_loja
        }`;
      }
      return this.$t("registrations.integrations.title");
    },
    integrations() {
      return [
        {
          image: "/playground_assets/pixel-logo.png",
          title: "Facebook Pixel",
          integration: "facebookPixel",
          info: this.$t("registrations.integrations.pixel-info"),
          description: this.$t("registrations.integrations.pixel-description"),
        },
        {
          image: "/playground_assets/analytics-logo.png",
          title: "Google Analytics",
          integration: "googleAnalytics",
          description: this.$t(
            "registrations.integrations.analyticts-description"
          ),
        },
        {
          image: "/playground_assets/ads-logo.png",
          title: "Google Ads",
          info: this.$t("registrations.integrations.ads-info"),
          integration: "googleAds",
          description: this.$t("registrations.integrations.ads-description"),
        },
        {
          image: "/playground_assets/gtm-logo.png",
          title: "Google Tag Manager",
          integration: "googleTagManager",
          description: this.$t(
            "registrations.integrations.tag-manager-description"
          ),
        },
      ];
    },
  },
  methods: {
    async openDialog(item) {
      const infoMessage = () => {
        switch (item.integration) {
          case "facebookPixel":
            return this.$t("registrations.integrations.pixel-dialog-info");
          case "googleAds":
            return this.$t("registrations.integrations.ads-dialog-info");
          case "googleAnalytics":
            return this.$t("registrations.integrations.analytics-dialog-info");
          case "googleTagManager":
            return this.$t(
              "registrations.integrations.tag-manager-dialog-info"
            );
          default:
            return "";
        }
      };

      await this.integrationsList().then(res => {
        const {
          facebookPixelID,
          facebookPixelTestID,
          facebookPixelToken,
          googleAdsID,
          googleAdsScript,
          googleAnalyticsID,
          googleTagManagerID,
        } = res;
        this.integration = Object.assign(
          {},
          {
            ...item,
            facebookPixelID: facebookPixelID || item.facebookPixelID || "",
            facebookPixelTestID:
              facebookPixelTestID || item.facebookPixelTestID || "",
            facebookPixelToken:
              facebookPixelToken || item.facebookPixelToken || "",
            googleAdsID: googleAdsID || item.googleAdsID || "",
            googleAdsScript: googleAdsScript || item.googleAdsScript || "",
            googleAnalyticsID:
              googleAnalyticsID || item.googleAnalyticsID || "",
            googleTagManagerID:
              googleTagManagerID || item.googleTagManagerID || "",
            infoMessage: infoMessage(),
          }
        );
      });

      this.dialog = true;
    },
    getStoreID() {
      if (this.isAdmin) {
        const haveInfo = this.storeInfo;

        if (!haveInfo) {
          this.openModalSelect();
          return;
        }

        const { sequenciador } = haveInfo;
        return sequenciador;
      }
      return this.storeInfo;
    },
    parseJSONWithDefault(jsonString, defaultValue = {}) {
      try {
        return JSON.parse(jsonString) || defaultValue;
      } catch (error) {
        console.error(error);
        return defaultValue;
      }
    },

    async integrationsList() {
      const { post } = this.$axios;
      const { LISTAR_LOJAS } = this.ENDPOINTS;
      if (this.storeSequencial === "") return;

      const filtros = [
        {
          campo: "sequenciador",
          tipo: "int",
          valor: this.storeSequencial,
        },
      ];

      const response = await post(LISTAR_LOJAS, { filtros })
        .then(response => {
          const {
            facebook_pixel,
            google_ads,
            google_analytics,
            google_tag_manager,
          } = response[0];
          const { facebookPixelID, facebookPixelTestID, facebookPixelToken } =
            facebook_pixel;

          const { googleAdsID = "", googleAdsScript = "" } =
            this.parseJSONWithDefault(google_ads);

          return {
            facebookPixelID: facebookPixelID || "",
            facebookPixelTestID: facebookPixelTestID || "",
            facebookPixelToken: facebookPixelToken || "",
            googleAdsID,
            googleAdsScript,
            googleAnalyticsID: google_analytics || "",
            googleTagManagerID: google_tag_manager || "",
          };
        })
        .catch(error => {
          throw new Error(error);
        });

      return response;
    },
    connectIntegration(integrationItem) {
      this.connectLoading = true;
      const { put } = this.$axios;
      const { ALTERAR_LOJA } = this.ENDPOINTS;
      const {
        facebookPixelID,
        facebookPixelTestID,
        facebookPixelToken,
        googleAnalyticsID,
        googleAdsID,
        googleAdsScript,
        googleTagManagerID,
      } = integrationItem;
      let dados = {
        facebook_pixel: {
          facebookPixelID,
          facebookPixelTestID,
          facebookPixelToken,
        },
        google_analytics: googleAnalyticsID,
        google_ads: { googleAdsID, googleAdsScript },
        google_tag_manager: googleTagManagerID,
      };

      put(`${ALTERAR_LOJA}${this.storeSequencial}`, JSON.stringify(dados))
        .then(() => {
          switch (integrationItem.integration) {
            case "facebookPixel":
              this.$config.alert(
                "Facebook Pixel da loja alterado",
                this.$config.dados.successColor
              );
              break;
            case "googleAds":
              this.$config.alert(
                "Google Ads da loja alterado",
                this.$config.dados.successColor
              );
              break;
            case "googleAnalytics":
              this.$config.alert(
                "Google Analytics da loja alterado",
                this.$config.dados.successColor
              );
              break;
            case "googleTagManager":
              this.$config.alert(
                "Google tag Manager da loja alterado",
                this.$config.dados.successColor
              );
              break;
            // Adicione mais cases para outras integrações aqui
            default:
              break;
          }
          this.dialog = false;
          this.integrationsList();
          this.connectLoading = false;
        })
        .catch(() => {
          this.connectLoading = false;
        });
    },
  },
};
</script>
<style scoped></style>
